import { render } from "./ReminderInputMail.vue?vue&type=template&id=15fcdf28&scoped=true"
import script from "./ReminderInputMail.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderInputMail.vue?vue&type=script&setup=true&lang=js"

import "./ReminderInputMail.vue?vue&type=style&index=0&id=15fcdf28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fcdf28"],['__file',"src/views/reminder/ReminderInputMail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15fcdf28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15fcdf28', __exports__)) {
    api.reload('15fcdf28', __exports__)
  }
  
  module.hot.accept("./ReminderInputMail.vue?vue&type=template&id=15fcdf28&scoped=true", () => {
    api.rerender('15fcdf28', render)
  })

}


export default __exports__